<template>
  <!-- 对话框 -->
  <el-dialog
    width="70%"
    top="2vh"
    :visible.sync="show"
    :before-close="closeDialog"
    :close-on-click-modal="false"
  >
    <div style="height: 72vh; overflow-y: auto">
      <!-- 高德地图 -->
      <div id="container_add"></div>
      <!-- 高德地图功能组件 -->
      <div class="form-box">
        <el-form ref="form">
          <el-form-item
            label=""
            label-width="125px"
          >
            <el-switch
              v-model="submit_data.coordinate_type"
              active-value="1"
              inactive-value="0"
              active-text="开启"
              inactive-text="关闭"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label=""
            label-width="50px"
          >
            <el-button
              type="success"
              @click="coordinateInit"
              style="display: block; margin: 0 auto 20px"
            >初始化围栏
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <!-- 对话框底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
    >
      <submitBtn
        :data="submit_data"
        :rules="submit_rules"
        url="/order/editModeCoordinateSubmit"
        @onSubmitDig="onSubmitDig"
        :JSON_Boolean="false"
      />

      <el-button @click="closeDialog">返回</el-button>
    </span>
  </el-dialog>
</template>

<script>
var _this,
    district,
    map,
    free_area_coordinate_array,
    far_area_coordinate_array,
    effective_area_coordinate_array,
    free_area_polygon,
    far_area_polygon,
    effective_area_polygon,
    free_area_polyEditor,
    far_area_polyEditor,
    effective_area_polyEditor;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            // _this.submit_data.city_tag = JSON.parse(
            //     localStorage.getItem("city_tag")
            // ).city_tag;
            _this.submit_data.order_mode_code = _this.data;
            _this.$nextTick(function () {
                // 地图加载完成后
                _this.mapinit().then((res) => {
                    // 获取订单模式详情
                    _this
                        .$post('/order/getOrderModeDetails', {
                            order_mode_code: _this.data,
                            city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                        })
                        .then((res) => {
                            _this.submit_data.coordinate_type = res.data.coordinate_type;

                            _this.submit_data.free_area_coordinate_array = res.data.free_area_coordinate_array;
                            _this.submit_data.far_area_coordinate_array = res.data.far_area_coordinate_array;
                            _this.submit_data.effective_area_coordinate_array = res.data.effective_area_coordinate_array;
                            console.log(JSON.parse(res.data.free_area_coordinate_array));

                            if (res.data.free_area_coordinate_array != null && res.data.free_area_coordinate_array != '' && res.data.free_area_coordinate_array != '[]') {
                                free_area_coordinate_array = JSON.parse(res.data.free_area_coordinate_array);
                                var free_area_polygon_path = free_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));
                                // 一小时围栏的初始化设置
                                free_area_polygon = new TMap.MultiPolygon({
                                    map: map,
                                    styles: {
                                        'freeStyle': new TMap.PolygonStyle({
                                            'borderColor': '#008000',
                                            'borderWidth': 6,
                                            'lineJoin': 'round',
                                            'lineCap': 'round'
                                        })
                                    },
                                    geometries: [{
                                        'id': 'free_area_polygon_id',
                                        'styleId': 'freeStyle',
                                        'paths': free_area_polygon_path
                                    }]
                                });

                                //一小时围栏画线
                                free_area_polyEditor = new TMap.tools.GeometryEditor({
                                    map, // 编辑器绑定的地图对象
                                    overlayList: [ // 可编辑图层
                                        {
                                            overlay: free_area_polygon,
                                            id: 'free_area_polygon_id',
                                        },
                                    ],
                                    actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
				                    activeOverlayId: 'free_area_polygon_id', // 激活图层
                                    selectable: true, // 开启点选功能
                                    snappable: true // 开启吸附
                                });
                                free_area_polyEditor.enable();
                                console.log(free_area_polyEditor,'一小时围栏触对象');
                                //改变一小时围栏触发
                                free_area_polyEditor.on('adjust_complete', function (event) {
                                    console.log(event,'event');
                                    let free_area_coordinate_array = event.paths;
                                    var free_area_array = [];

                                    // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                                    for (let i = 0; i < free_area_coordinate_array.length; i++) {
                                        free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                                    }
                                    console.log(free_area_array);
                                    _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
                                });
                                free_area_polyEditor.on('delete_complete', function (event) {
                                    _this.submit_data.free_area_coordinate_array = "";
                                });
                            }

                            if (res.data.far_area_coordinate_array != null && res.data.far_area_coordinate_array != '' && res.data.far_area_coordinate_array != '[]') {
                                // 超远围栏做标组
                                far_area_coordinate_array = JSON.parse(res.data.far_area_coordinate_array);
                                var far_area_polygon_path = far_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));
                                // 超远围栏的初始化设置
                                far_area_polygon = new TMap.MultiPolygon({
                                    map: map,
                                    styles: {
                                        'farStyle': new TMap.PolygonStyle({
                                            'borderColor': '#FF33FF',
                                            'borderWidth': 6,
                                            'lineJoin': 'round',
                                            'lineCap': 'round'
                                        })
                                    },
                                    geometries: [{
                                        'id': 'far_area_polygon_id',
                                        'styleId': 'farStyle',
                                        'paths': far_area_polygon_path
                                    }]
                                });
                                //改变超远围栏触发
                                far_area_polyEditor = new TMap.tools.GeometryEditor({
                                    map, // 编辑器绑定的地图对象
                                    overlayList: [ // 可编辑图层
                                        {
                                            overlay: far_area_polygon,
                                            id: 'far_area_polygon_id',
                                        },
                                    ],
                                    actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
				                    activeOverlayId: 'far_area_polygon_id', // 激活图层
                                    selectable: true, // 开启点选功能
                                    snappable: true // 开启吸附
                                });
                                far_area_polyEditor.enable();
                                //改变一小时围栏触发
                                far_area_polyEditor.on('adjust_complete', function (event) {
                                    console.log(event,'event');
                                    let far_area_coordinate_array = event.paths;
                                    var far_area_array = [];

                                    // 遍历将far_area_coordinate_array的坐标值存到far_area_array数组中
                                    for (let i = 0; i < far_area_coordinate_array.length; i++) {
                                        far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                                    }
                                    console.log(far_area_array);
                                    _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
                                });

                                far_area_polyEditor.on('delete_complete', function (event) {
                                    _this.submit_data.far_area_coordinate_array = "";
                                });
                            }

                            if (res.data.effective_area_coordinate_array != null && res.data.effective_area_coordinate_array != '' && res.data.effective_area_coordinate_array != '[]') {
                                // 有效围栏坐标组
                                effective_area_coordinate_array = JSON.parse(res.data.effective_area_coordinate_array);
                                var effective_area_polygon_path = effective_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));
                                // 有效围栏的初始化设置
                                effective_area_polygon = new TMap.MultiPolygon({
                                    map: map,
                                    styles: {
                                        'effectiveStyle': new TMap.PolygonStyle({
                                            'borderColor': '#000000',
                                            'borderWidth': 6,
                                            'lineJoin': 'round',
                                            'lineCap': 'round'
                                        })
                                    },
                                    geometries: [{
                                        'id': 'effective_area_polygon_id',
                                        'styleId': 'effectiveStyle',
                                        'paths': effective_area_polygon_path
                                    }]
                                });
                                effective_area_polyEditor = new TMap.tools.GeometryEditor({
                                    map, // 编辑器绑定的地图对象
                                    overlayList: [ // 可编辑图层
                                        {
                                            overlay: effective_area_polygon,
                                            id: 'effective_area_polygon_id',
                                        },
                                    ],
                                    actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
				                    activeOverlayId: 'effective_area_polygon_id', // 激活图层
                                    selectable: true, // 开启点选功能
                                    snappable: true // 开启吸附
                                });
                                effective_area_polyEditor.enable();
                                //改变有效围栏触发
                                effective_area_polyEditor.on('adjust_complete', function (event) {
                                    console.log(event,'event');
                                    let effective_area_coordinate_array = event.paths;
                                    var effective_area_array = [];

                                    // 遍历将far_area_coordinate_array的坐标值存到far_area_array数组中
                                    for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                                        effective_area_array.push([effective_area_coordinate_array[i].lng, effective_area_coordinate_array[i].lat]);
                                    }
                                    console.log(effective_area_array);
                                    _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);
                                });
                                effective_area_polyEditor.on('delete_complete', function (event) {
                                    _this.submit_data.effective_area_coordinate_array = "";
                                });
                            }
                        })
                        .catch((err) => {});
                });
            });
        }
    },
    data() {
        return {
            show: false,

            // 第一页表单数据
            submit_data: {
                order_mode_code: '',
                coordinate_type: '0',
                free_area_coordinate_array: '',
                far_area_coordinate_array: '',
                effective_area_coordinate_array: ''
            },

            submit_rules: {
                order_mode_code: {
                    placeholder: '订单模式唯一编码',
                    rules: {
                        required: true,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                coordinate_type: {
                    placeholder: '状态',
                    rules: {
                        required: true,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                free_area_coordinate_array: {
                    placeholder: '一小时围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                far_area_coordinate_array: {
                    placeholder: '超远围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                effective_area_coordinate_array: {
                    placeholder: '有效围栏坐标组',
                    rules: {
                        required: false,
                        message: '',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        async mapinit() {
            // 地图初始化
            map = new TMap.Map('container_add', {
                zoom: 11,
                viewMode: '2D'
            });

            var loginCityName = JSON.parse(localStorage.getItem('login')).city.name;

            var x = loginCityName.indexOf('/');

            for (var i = 0; i < 1; i++) {
                x = loginCityName.indexOf('/', x + 1);
            }

            // 如果为市级
            if (x < 0) {
                // 截取城市名称 如:XXXX / 截取字段
                var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2);
            } else {
                // 截取城市名称 如:XXXX / XXXX / 截取字段
                var city_name = loginCityName.slice(x + 2);
            }
            console.log(city_name);
            // 设置地图中心点
            _this
                .$post('/admin.php/city/getCityDetails')
                    .then((res) => {
                        var center = res.data.center;
                        const [lng, lat] = center.split(',').map(Number);
                        console.log(center);
                        map.setCenter(new TMap.LatLng(lat, lng));

                    })
                    .catch((err) => {});
        },

        // 初始化围栏按钮
        coordinateInit() {
            var mapCenter = map.getCenter();
            // console.log(free_area_polyEditor, '111');

            console.log(far_area_polyEditor);
            // console.log(effective_area_polygon);
            if (free_area_polyEditor) {
                console.log(3331);
                free_area_polyEditor.destroy();

                _this.submit_data.free_area_coordinate_array = '';
            }

            if (far_area_polyEditor) {
                console.log(3332);
                far_area_polyEditor.destroy();

                _this.submit_data.far_area_coordinate_array = '';
            }

            if (effective_area_polyEditor) {
                console.log(3333);
                effective_area_polyEditor.destroy();

                _this.submit_data.effective_area_coordinate_array = '';
            }

            if (free_area_polygon) {
                // 移除一小时围栏
                free_area_polygon.remove('free_area_polygon_id');
            }
            if (far_area_polygon) {
                // 移除超远围栏
                far_area_polygon.remove('far_area_polygon_id');
            }

            if (effective_area_polygon) {
                // 移除有效围栏
                effective_area_polygon.remove('effective_area_polygon_id');
            }

            // 一小时围栏做标组
            free_area_coordinate_array = [
                [mapCenter.lng + 0.03, mapCenter.lat],
                [mapCenter.lng - 0.03, mapCenter.lat - 0.03],
                [mapCenter.lng - 0.03, mapCenter.lat + 0.03]
            ];
            var free_area_polygon_path = free_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));
            // 超远围栏做标组
            far_area_coordinate_array = [
                [mapCenter.lng + 0.06, mapCenter.lat],
                [mapCenter.lng - 0.06, mapCenter.lat - 0.06],
                [mapCenter.lng - 0.06, mapCenter.lat + 0.06]
            ];
            var far_area_polygon_path = far_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));

            // 有效围栏坐标组
            effective_area_coordinate_array = [
                [mapCenter.lng + 0.09, mapCenter.lat],
                [mapCenter.lng - 0.09, mapCenter.lat - 0.09],
                [mapCenter.lng - 0.09, mapCenter.lat + 0.09]
            ];
            var effective_area_polygon_path = effective_area_coordinate_array.map(coord => new TMap.LatLng(coord[1], coord[0]));

            // 一小时围栏的初始化设置
            free_area_polygon = new TMap.MultiPolygon({
                map: map,
                styles: {
                    'freeStyle': new TMap.PolygonStyle({
                        'borderColor': '#008000',
                        'borderWidth': 6,
                        'lineJoin': 'round',
                        'lineCap': 'round'
                    })
                },
                geometries: [{
                    'id': 'free_area_polygon_id',
                    'styleId': 'freeStyle',
                    'paths': free_area_polygon_path
                }]
            });

            // 超远围栏的初始化设置
             far_area_polygon = new TMap.MultiPolygon({
                map: map,
                styles: {
                    'farStyle': new TMap.PolygonStyle({
                        'borderColor': '#FF33FF',
                        'borderWidth': 6,
                        'lineJoin': 'round',
                        'lineCap': 'round'
                    })
                },
                geometries: [{
                    'id': 'far_area_polygon_id',
                    'styleId': 'farStyle',
                    'paths': far_area_polygon_path
                }]
            });

            // 有效围栏的初始化设置
             effective_area_polygon = new TMap.MultiPolygon({
                map: map,
                styles: {
                    'effectiveStyle': new TMap.PolygonStyle({
                        'borderColor': '#000000',
                        'borderWidth': 6,
                        'lineJoin': 'round',
                        'lineCap': 'round'
                    })
                },
                geometries: [{
                    'id': 'effective_area_polygon_id',
                    'styleId': 'effectiveStyle',
                    'paths': effective_area_polygon_path
                }]
            });

            // 缩放地图到合适的视野级别
            // 假设您有一组坐标点
            // var coords = free_area_polygon;

            // // 创建LatLngBounds实例
            // var latlngBounds = new TMap.LatLngBounds();

            // // 将坐标逐一传入extend方法，latlngBounds会自动扩展生成
            // for (var i = 0; i < coords.length; i++) {
            //     latlngBounds.extend(coords[i]);
            // }
            // // 调用fitBounds自动调整地图显示范围
            // map.fitBounds(latlngBounds);

            //一小时围栏画线
            free_area_polyEditor = new TMap.tools.GeometryEditor({
                map, // 编辑器绑定的地图对象
                overlayList: [ // 可编辑图层
                    {
                        overlay: free_area_polygon,
                        id: 'free_area_polygon_id',
                    },
                ],
                actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
                activeOverlayId: 'free_area_polygon_id', // 激活图层
                selectable: true, // 开启点选功能
                snappable: true // 开启吸附
            });
            free_area_polyEditor.enable();

            //超远围栏画线
             far_area_polyEditor = new TMap.tools.GeometryEditor({
                map, // 编辑器绑定的地图对象
                overlayList: [ // 可编辑图层
                    {
                        overlay: far_area_polygon,
                        id: 'far_area_polygon_id',
                    },
                ],
                actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
                activeOverlayId: 'far_area_polygon_id', // 激活图层
                selectable: true, // 开启点选功能
                snappable: true // 开启吸附
            });
            far_area_polyEditor.enable();

            //有效围栏画线
             effective_area_polyEditor = new TMap.tools.GeometryEditor({
                map, // 编辑器绑定的地图对象
                overlayList: [ // 可编辑图层
                    {
                        overlay: effective_area_polygon,
                        id: 'effective_area_polygon_id',
                    },
                ],
                actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, // 编辑器的工作模式
                activeOverlayId: 'effective_area_polygon_id', // 激活图层
                selectable: true, // 开启点选功能
                snappable: true // 开启吸附
            });
            effective_area_polyEditor.enable();

            //改变一小时围栏触发
            free_area_polyEditor.on('adjust_complete', function (event) {
                console.log(event,'event');
                let free_area_coordinate_array = event.paths;
                var free_area_array = [];

                // 遍历将free_area_coordinate_array的坐标值存到free_area_array数组中
                for (let i = 0; i < free_area_coordinate_array.length; i++) {
                    free_area_array.push([free_area_coordinate_array[i].lng, free_area_coordinate_array[i].lat]);
                }

                _this.submit_data.free_area_coordinate_array = JSON.stringify(free_area_array);
            });
            //改变一小时围栏触发
            free_area_polyEditor.on('delete_complete', function (event) {
                console.log('删除折线上某个点时触发此事件');
                _this.submit_data.free_area_coordinate_array = "";
            });

            //改变超远围栏触发
            far_area_polyEditor.on('adjust_complete', function (event) {
                console.log(event,'event');
                let far_area_coordinate_array = event.paths;
                var far_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < far_area_coordinate_array.length; i++) {
                    far_area_array.push([far_area_coordinate_array[i].lng, far_area_coordinate_array[i].lat]);
                }

                _this.submit_data.far_area_coordinate_array = JSON.stringify(far_area_array);
            });
            //改变超远围栏触发
            far_area_polyEditor.on('delete_complete', function (event) {
                console.log('删除折线上某个点时触发此事件');
                _this.submit_data.far_area_coordinate_array = "";
            });

            //改变有效围栏触发
            effective_area_polyEditor.on('adjust_complete', function (event) {
                console.log(event,'event');
                let effective_area_coordinate_array = event.paths;
                var effective_area_array = [];

                // 遍历将path的坐标值存到polygon2_path数组中
                for (let i = 0; i < effective_area_coordinate_array.length; i++) {
                    effective_area_array.push([effective_area_coordinate_array[i].lng, effective_area_coordinate_array[i].lat]);
                }

                _this.submit_data.effective_area_coordinate_array = JSON.stringify(effective_area_array);
            });
            //改变有效围栏触发
            effective_area_polyEditor.on('delete_complete', function (event) {
                console.log('删除折线上某个点时触发此事件');
                _this.submit_data.effective_area_coordinate_array = "";
            });
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');

            _this.closeDialog();
        },

        closeDialog() {
            console.log(111);
            _this.show = false;
            free_area_polygon = undefined;
            far_area_polygon = undefined;
            effective_area_polygon = undefined;
            free_area_polyEditor = undefined;
            far_area_polyEditor = undefined;
            effective_area_polyEditor = undefined;
            map.destroy();
            _this.submit_data = {
                order_mode_code: '',
                coordinate_type: '0',
                free_area_coordinate_array: '',
                far_area_coordinate_array: '',
                effective_area_coordinate_array: ''
            };
        }
    }
};
</script>

<style scoped>
/* 高德地图css */
/* @import "https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css";
    @import "https://a.amap.com/jsapi_demos/static/demo-center/css/prety-json.css"; */

#container_add {
    height: 100%;
    width: 80%;
    float: left;
}

.form-box {
    width: 20%;
    padding: 20px;
    box-sizing: border-box;
    float: left;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>
